'use strict';

app.farmnetControllers = {};

app.farmnetControllers.resolvers = {};
/* helper function to allow controller registration in any phase */

app.farmnetControllers.register = function(name, func, resolveFunc) {
  /* if the app is in loading phase, register the controller in config phase */
  if (app.register == null) {
    app.config(function() {
      app.register.controller(name, func);
    });
  } else {
    /* if the app is allready running just regsiter the new controller */
    app.register.controller(name, func);
  }
  if (resolveFunc != undefined) {
    app.farmnetControllers.resolvers[name] = resolveFunc;
  }
  return func;
};

app.farmnetControllers.customCodes = {}; // functions that enhance the generated controllers

// finish controller initialisation
app.farmnetControllers.finishController = function(
  name,
  scope,
  controller,
  $injector
) {
  scope[name] = controller;
  // call custom code if possible
  if (this.customCodes[name] != undefined) {
    this.customCodes[name](scope, controller, $injector);
  }
  return controller;
};
app.farmnetControllers.addCustomCode = function(name, func) {
  //console.debug("adding custom code for "+name);
  if (this.customCodes[name]) {
    console.error('Overwritting custom func for:' + name);
  }
  this.customCodes[name] = func; // TODO: do we want to allow multiple custom codes per name ?
};

/* load all controllers that are required before page load */
app.farmnetControllers.load = function(afterFunc) {
  afterFunc();
};

/* fallback for legacy code
 * TODO: remove this code at some point when all other controllers use the new namespace
 */
var controllers = {};
for (var prop in app.farmnetControllers) {
  if (typeof app.farmnetControllers[prop] != 'function') {
    controllers[prop] = app.farmnetControllers[prop];
  } else {
    // closure to keep the prop through the loop
    (function(prop) {
      controllers[prop] = function() {
        console.info(
          'using deprecated global controller, method:',
          prop,
          arguments[0]
        );
        return app.farmnetControllers[prop].apply(
          app.farmnetControllers,
          arguments
        );
      };
    })(prop);
  }
}

global.controllers = controllers;
